import React, { Component } from 'react';
import { Header, Modal } from 'semantic-ui-react';
import { Form, Button, TextArea } from 'formik-semantic-ui';
import { EUserGroup } from '@relab/alstom-ptw-shared';

import { UserSelectComponent } from '../UserSelectComponent';
import { TranslationComponent } from '../TranslationComponent';
import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

export interface PtwQualityTestRequestedModalValues {
  user: string;
  qualityNotes: string;
}

interface PtwQualityTestRequestedModalProps {
  i18n: typeof i18n;
  t: typeof i18n.t;
  projectId: string;
  onSubmit: any;
}

class PPtwQualityTestRequestedModal extends Component<PtwQualityTestRequestedModalProps> {
  state: { open: boolean } = {
    open: false,
  };

  toggleOpen = (open: boolean) => {
    this.setState({ open });
  };

  render() {
    const { t } = this.props;
    return (
      <Modal
        open={this.state.open}
        onClose={() => this.toggleOpen(false)}
        trigger={
          <Button primary onClick={() => this.toggleOpen(true)}>
            <TranslationComponent stringKey={'Quality test'} />
          </Button>
        }
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Add quality infos'} />
        </Modal.Header>
        <Modal.Content>
          <Form initialValues={{ user: null, qualityNotes: '' }} onSubmit={this.props.onSubmit}>
            <Header as="h5">
              <TranslationComponent stringKey={'Quality user'} />
            </Header>
            <UserSelectComponent name="user" projectId={this.props.projectId} group={EUserGroup.QUALITY} />
            <TextArea label={t('Quality notes')} name="qualityNotes" />
            <Button onClick={() => this.toggleOpen(false)}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button.Submit>
              <TranslationComponent stringKey={'Confirm'} />
            </Button.Submit>
          </Form>
        </Modal.Content>
      </Modal>
    );
  }
}

export const PtwQualityTestRequestedModal = withTranslation()(PPtwQualityTestRequestedModal);
